import { useEffect, useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_REVIEWABILITY } from '../queries/reviewabilityQuery';
import { EDIT_PENDING, PENDING } from '../constants/UnreviewableReason';
export function useReviewability({
  editPending,
  entityId,
  entityPortalId,
  isPublicApp,
  reviewPending,
  reviewType,
  skip
}) {
  const {
    error,
    loading,
    refetch
  } = useQuery(GET_REVIEWABILITY, {
    variables: {
      type: reviewType,
      entityId,
      entityPortalId
    },
    skip: isPublicApp || skip
  });
  const reviewabilityRequestStatus = loading ? 'PENDING' : 'SUCCEEDED';
  useEffect(() => {
    if (!isPublicApp && !skip && entityId && entityPortalId) {
      refetch().catch(() => {
        // pass through
      });
    }
  }, [entityId, entityPortalId, isPublicApp, skip, refetch]);
  const unreviewableReason = useMemo(() => {
    if (reviewPending) {
      return `ReviewError.${PENDING}`;
    }
    if (editPending) {
      return `ReviewError.${EDIT_PENDING}`;
    }
    if (error && reviewabilityRequestStatus === 'SUCCEEDED') {
      try {
        const data = JSON.parse(error.networkError.data);
        if ('subCategory' in data) {
          return data.subCategory;
        }
        if ('errors' in data) {
          return data.errors[0].subCategory;
        }
        return 'ReviewError.GENERIC_UNREVIEWABLE';
      } catch (e) {
        return 'ReviewError.GENERIC_UNREVIEWABLE';
      }
    }
    return null;
  }, [editPending, reviewPending, reviewabilityRequestStatus, error]);
  return {
    unreviewableReason,
    requestState: loading || skip || !entityId || !entityPortalId ? 'PENDING' : 'SUCCEEDED'
  };
}